import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-provide',
  templateUrl: './services-provide.component.html',
  styleUrls: ['./services-provide.component.scss']
})
export class ServicesProvideComponent implements OnInit {

  constructor() { }

  services = [
    {
      imageUrl: '../../../../assets/images/screen.svg',
      title: ' Digital Product Engineering',
      desc: ' UI/UX | Frontend | API | Web | Mobile | Dev',
    },
    {
      imageUrl: '../../../../assets/images/upload.svg',
      title: 'Cloud & Devops',
      desc: 'DevOps Automation | SRE | Cloud Migrations | Cloud Spend Management',
    },
    {
      imageUrl: '../../../../assets/images/touch.svg',
      title: 'Digital Transformation',
      desc: 'SEO | SEM | Creative & Design | Media | Email & Marketing Automation',
    },
    {
      imageUrl: '../../../../assets/images/patch/services-home/qualityEngineering.svg',
      title: 'Quality Engineering',
      desc: 'Service quality assurance and control',
    },
    {
      imageUrl: '../../../../assets/images/patch/services-home/chatbotDevelopment.svg',
      title: 'Chatbot Development',
      desc: 'Artificial Intelligence (AI) software service',
    },
    {
      imageUrl: '../../../../assets/images/patch/services-home/managedServices.svg',
      title: 'Managed Services',
      desc: '24X7 Managed Services',
    },
    {
      imageUrl: '../../../../assets/images/patch/services-home/staffAgumentation.svg',
      title: 'Staff Agumentation',
      desc: 'Staff outsourcing for a project',
    },
    {
      imageUrl: '../../../../assets/images/patch/services-home/customisedCRM.svg',
      title: 'Customized CRM Solutions',
      desc: 'Customized CRM Solutions',
    },
    {
      imageUrl: '../../../../assets/images/patch/services-home/dataAndAnalytical.svg',
      title: 'Data & Analytics',
      desc: 'Data Engineering | BI & Data Analysis | Data Science & ML | Digital Analytics',
    },
  ]

  ngOnInit(): void {
  }

}
